import { render, staticRenderFns } from "./ArticleScan.vue?vue&type=template&id=242686c6&scoped=true"
import script from "./ArticleScan.vue?vue&type=script&lang=js"
export * from "./ArticleScan.vue?vue&type=script&lang=js"
import style0 from "./ArticleScan.vue?vue&type=style&index=0&id=242686c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242686c6",
  null
  
)

export default component.exports